export default __webpack_public_path__ + "static/media/bgLogIn.44e96a25.png";